export const ChoiceCard = ({
  icon: Icon,
  title,
  description,
  timeEstimate,
  popular = false,
  disabled = false,
  badge,
  onSelect
}) => (
  <button
    type="button"
    className={`choice-card${popular ? ' choice-card--popular' : ''}${disabled ? ' choice-card--disabled' : ''}`}
    disabled={disabled}
    onClick={disabled ? undefined : onSelect}
  >
    <div className="choice-card__icon">
      <Icon width={28} height={28} />
    </div>
    <div className="choice-card__title-row">
      <span className="choice-card__title">{title}</span>
      {popular && <span className="choice-card__badge">Popular</span>}
      {badge && <span className="choice-card__badge choice-card__badge--neutral">{badge}</span>}
    </div>
    <p className="choice-card__description">{description}</p>
    {timeEstimate && <span className="choice-card__time">{timeEstimate}</span>}
  </button>
);
